import React, { useState } from 'react';
import Box from '../../../../components/Box';
import { Helpers } from '../../../../helpers/Helpers';
import { GetVehicleByIdResponseVehiclePassCard } from '../../../../models/response/vehicle/GetVehicleByIdResponse';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import toast from "react-hot-toast";
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { useDispatch } from 'react-redux';
import CustomSwitch from '../../../../components/CustomSwitch';
import { ayniAdliAktifVar } from '../../../../helpers/gecisKarti';

interface Props {
    passCardsRef: any
    vehiclePassCards: GetVehicleByIdResponseVehiclePassCard[]
    setVehiclePassCards: React.Dispatch<React.SetStateAction<GetVehicleByIdResponseVehiclePassCard[]>>
}

const PassCards = ({
    passCardsRef,
    vehiclePassCards,
    setVehiclePassCards
}: Props) => {
    const dispatch = useDispatch();
    const [vehiclePassCardId, setVehiclePassCardId] = useState('');
    const [cardName, setCardName] = useState('');
    const [cardNo, setCardNo] = useState('');
    const [isPassCardActive, setIsPassCardActive] = useState(true);
    const [isOpen, setIsOpen] = useState(false);

    const setUpdateItem = () => {
        var o = vehiclePassCards.filter(x => x.isSelected)[0];

        setVehiclePassCardId(o.vehiclePassCardId);
        setCardName(o.cardName);
        setCardNo(o.cardNo);
        setIsPassCardActive(o.isCustomActive);
        setIsOpen(true);
        scrollTo();
    }

    const deleteItems = () => {
        setVehiclePassCards(vehiclePassCards.filter(x => !x.isSelected));
    }

    const selectAll = () => {
        var isAllSelected = vehiclePassCards.length == vehiclePassCards.filter(x => x.isSelected).length;

        setVehiclePassCards(vehiclePassCards.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setItemSelected = (_id: string) => {
        setVehiclePassCards(vehiclePassCards.map(function (x) {
            if (x.vehiclePassCardId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const saveItem = () => {
        if (Helpers.isEmpty(cardName)) {
            toast.error('Kart Adı alanını doldurunuz!');
            return;
        }
        if (Helpers.isEmpty(cardNo)) {
            toast.error('Kart No alanını doldurunuz!');
            return;
        }
        // Aynı adla iki aktif kart olamaz: HGS aktarımı aracın aktif HGS kartıyla eşleşir (04.11.2026).
        const kartlar = vehiclePassCards.map(x => ({ id: x.vehiclePassCardId, ad: x.cardName, aktif: x.isCustomActive }));
        if (ayniAdliAktifVar(kartlar, { id: vehiclePassCardId, ad: cardName, aktif: isPassCardActive })) {
            toast.error(`Aynı kart adıyla (${cardName.trim()}) aktif bir geçiş kartı zaten var. Önce eski kartı pasife alın.`);
            return;
        }

        if (Helpers.isEmpty(vehiclePassCardId)) {
            var o: GetVehicleByIdResponseVehiclePassCard = {
                cardName: cardName,
                cardNo: cardNo,
                isCustomActive: isPassCardActive,
                vehiclePassCardId: Helpers.generateUUID(),
                isSelected: false
            }

            setVehiclePassCards([...vehiclePassCards, o])
        }
        else {
            setVehiclePassCards(vehiclePassCards.map(function (x) {
                if (x.vehiclePassCardId == vehiclePassCardId) {
                    x.cardName = cardName;
                    x.cardNo = cardNo;
                    x.isCustomActive = isPassCardActive;
                    x.isSelected = false;
                }

                return x;
            }))
        }

        setVehiclePassCardId('');
        setCardName('');
        setCardNo('');
        setIsPassCardActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setVehiclePassCardId('');
        setCardName('');
        setCardNo('');
        setIsPassCardActive(true);
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = passCardsRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    return (
        <div className='containerPart' ref={passCardsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Araç Geçiş Kartları</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kart Adı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={cardName} onChange={(e) => setCardName(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Kart No</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={cardNo} onChange={(e) => setCardNo(e.target.value)} type="text" className="form-control form-control-solid" />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                        <CustomSwitch isActive={isPassCardActive} setIsActive={setIsPassCardActive} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={vehiclePassCards.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={vehiclePassCards.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={vehiclePassCards.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={vehiclePassCards.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={vehiclePassCards.filter(x => x.isSelected).length > 0 && vehiclePassCards.filter(x => x.isSelected).length == vehiclePassCards.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Kart Adı</th>
                                            <th>Kart No</th>
                                            <th>Durum</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            vehiclePassCards.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            vehiclePassCards.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.vehiclePassCardId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.cardName}</td>
                                                    <td>{item.cardNo}</td>
                                                    <td>{item.isCustomActive ? <i style={{ fontSize: 20 }} className="text-success fa fa-check-circle" /> : <i style={{ fontSize: 20 }} className="text-danger fa fa-times-circle" />}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default PassCards;